import React, { useState } from 'react';
const Pagination = ({ perPage, navContainerLabel, pageLabelPrefix, prevPageLabel, nextPageLabel, children }) => {
    const startPage = 0; // pages have 0 based index
    const totalPages = Math.ceil(children.length / perPage);
    const [page, setPage] = useState(startPage);
    return (React.createElement("div", { className: "pagination__container" },
        children.slice(page * perPage, page * perPage + perPage),
        React.createElement("nav", { className: "pagination__navigation", "aria-label": navContainerLabel },
            React.createElement("ul", { className: "pagination__navigation-list" },
                page > startPage && (React.createElement("li", null,
                    React.createElement("button", { className: "pagination__navigation-button pagination__prev", onClick: () => {
                            setPage((page) => page - 1);
                        } },
                        React.createElement("i", { className: "fa-solid fa-arrow-left" }),
                        prevPageLabel))),
                (() => {
                    let rows = [];
                    for (let i = 0; i < totalPages; i++) {
                        rows.push(React.createElement("li", { key: i },
                            React.createElement("button", { className: 'pagination__navigation-button' + (i === page ? ' active-page' : ''), "aria-current": i === page ? 'page' : undefined, "aria-label": pageLabelPrefix + ' ' + (i + 1), onClick: () => {
                                    setPage(i);
                                } }, i + 1)));
                    }
                    return rows;
                })(),
                page < totalPages - 1 && (React.createElement("li", null,
                    React.createElement("button", { className: "pagination__navigation-button pagination__next", onClick: () => {
                            setPage((page) => page + 1);
                        } },
                        nextPageLabel,
                        React.createElement("i", { className: "fa-solid fa-arrow-right" }))))))));
};
export default Pagination;
